import React from 'react'
import A_FieldCheckBox from '../A_FieldCheckBox'
import { inputF } from 'types/FunctionTypes'

type Props = {
  label: string
  isChecked: boolean
  event: inputF
  disabled?: boolean
  alert?: boolean
}

/**
 * ラベルが右にあるチェックボックス
 * @param param0
 * @returns
 */
const M_FieldCheckRight = ({ label, isChecked, event, disabled = false, alert = false }: Props) => {
  return (
    <A_FieldCheckBox
      label={label} //
      check={isChecked}
      change={event}
      disabled={disabled}
      position="end"
      color={alert ? 'secondary' : 'primary'}
    />
  )
}

export default React.memo(M_FieldCheckRight)
